import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsSearchText = simpleSet as
  redux.reducers.calculationMode.settings.materials.pulls.searchText;

export const searchText = setCalculationModePullsSearchText(
  'SET_CALCULATION_MODE_PULLS_SEARCH_TEXT',
  ''
);
